import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ClerkProvider } from '@clerk/clerk-react';
import App from './App';
import { MeProvider } from './lib/me';
import './styles.css';

const clerkKey = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY;
if (!clerkKey) {
  console.warn('VITE_CLERK_PUBLISHABLE_KEY is not set — auth flows will not work.');
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ClerkProvider publishableKey={clerkKey ?? ''}>
      <BrowserRouter>
        <MeProvider>
          <App />
        </MeProvider>
      </BrowserRouter>
    </ClerkProvider>
  </React.StrictMode>
);
